import { Organization, UserModel, UserRoleModel } from '../../gs-core/common';

export const UC_DAVIS = UserModel.create({
  id: 302503,
  code: 'UCD',
  name: 'UC Davis Campus',
  clazz: 'edu.ucdavis.gs.people.Institution'
}) as Organization;

export const GRADUATE_STUDIES_DEANS_OFFICE = UserModel.create({
  id: 486848,
  code: '061300',
  name: 'Graduate Studies Dean\'s Office',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;

export const GRADUATE_SCHOOL = UserModel.create({
  id: 14,
  code: 'GS',
  name: 'Graduate School',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;

export const BUSINESS_SCHOOL = UserModel.create({
  id: 18,
  code: 'SM',
  name: 'Graduate School of Management',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;

export const LAW_SCHOOL = UserModel.create({
  id: 16,
  code: 'LW',
  name: 'School of Law',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;

export const VET_SCHOOL = UserModel.create({
  id: 20,
  code: 'VM',
  name: 'School of Veterinary Medicine',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;

export const MED_SCHOOL = UserModel.create({
  id: 17,
  code: 'MD',
  name: 'School of Medicine',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;

export const NURSING_SCHOOL = UserModel.create({
  id: 302477,
  code: 'NS',
  name: 'School of Nursing',
  roles: [
    UserRoleModel.create({
      code: 'SUBUNIT',
      group: UC_DAVIS
    })
  ]
}) as Organization;



// WEBPACK FOOTER //
// ./src/common/models/CampusDivisions.ts